export default __webpack_public_path__ + "static/media/fishing.24d3cff6.jpg";